import { client } from '@/client';

// 查询集群变量
export function getClusterVars(params) {
  return client.post('/api/ops_var/clusterVar/list', params);
}

// 保存为变量模板
export function saveNewStencil(params) {
  return client.post('/api/ops_var/clusterVar/saveNewStencil', params);
}
